import * as DarkReader from 'darkreader';
import { TRUSTED_ORIGIN_REGEX } from 'EmailEditorUI/utils/helpers';
window.addEventListener('message', event => {
  if (event.isTrusted && TRUSTED_ORIGIN_REGEX.test(event.origin) && event.data.type === 'TOGGLE_DARK_MODE') {
    if (event.data.isDarkMode) {
      DarkReader.setFetchMethod(window.fetch);
      DarkReader.enable({
        brightness: 100,
        contrast: 90,
        sepia: 10
      });
    } else {
      DarkReader.disable();
    }
  }
});